import { useEffect, useState } from "react";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { MdOutlineClose } from "react-icons/md";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { set_active_profile } from "../../redux/slices/influencerProfileSlice";
import { AGENCY_INFLUENCER_STORAGE_KEY } from "../../constants";

const SubscriptionBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [isExpired, setIsExpired] = useState(false);
  const user = useSelector(state => state.user);
  const agency_as_influencer = useSelector(state => state.influencer_profile.active);
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const handleRedirection = () => {
    if(agency_as_influencer){
       dispatch(set_active_profile(null))
      localStorage.removeItem(AGENCY_INFLUENCER_STORAGE_KEY)
    }
      navigate("/pricing")
  }
  
  // Get subscription data
  const subscriptionData = user?.subscription?.current_period_end 
    ? user.subscription 
    : user?.free_subscription?.is_paid === "free" 
      ? user.free_subscription 
      : {};

  // Calculate days remaining
  const calculateDaysRemaining = () => {
    if (!subscriptionData?.current_period_end) return null;

    const periodEndDate = new Date(subscriptionData?.current_period_end);
    const currentDate = new Date();

    currentDate.setHours(0, 0, 0, 0);
    periodEndDate.setHours(0, 0, 0, 0);
    
    const timeDiff = periodEndDate - currentDate;
    const daysRemaining = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    
    return daysRemaining;
  };

  const daysRemaining = calculateDaysRemaining();

  useEffect(() => {
    if (daysRemaining === null) return;

    const bannerDismissed = localStorage.getItem("subscriptionBannerDismissed");
    const nowExpired = daysRemaining < 0;

    setIsExpired(nowExpired);

    if ((!bannerDismissed || nowExpired) && daysRemaining <= 3 && subscriptionData?.status !== "active") {
      setShowBanner(true);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [daysRemaining]);

  const handleClose = () => {
    if (isExpired) return; // Don't allow closing if expired
    
    // localStorage.setItem("subscriptionBannerDismissed", "true");
    setShowBanner(false);
    document.body.style.overflow = "";
  };

  if (!showBanner) return null;

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-70 flex items-center justify-center z-[1001]">
      <div className="bg-white text-gray-800 p-6 rounded-lg shadow-xl w-11/12 max-w-md relative text-center">
        {/* Close Button - only show if not expired */}
        {!isExpired && (
          <button
            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 text-2xl font-bold"
            onClick={handleClose}
            aria-label="Close"
          >
            <MdOutlineClose />
          </button>
        )}

        <AiOutlineExclamationCircle className="text-red-500 text-6xl mx-auto mb-3" />

        {isExpired ? (
          <>
            <h2 className="text-lg font-semibold text-t-light">
              <FormattedMessage 
                id="subscription_expired_title" 
                defaultMessage="Your subscription has expired!" 
              />
            </h2>
            <p className="text-sm text-gray-700 mt-2 mb-7">
              <FormattedMessage
                id="subscription_expired"
                defaultMessage="Please renew your subscription to regain access to all features."
              />
            </p>
          </>
        ) : (
          <>
            <h2 className="text-lg font-semibold text-t-light">
              <FormattedMessage 
                id="subscription_warning_title" 
                defaultMessage="Your subscription is ending soon!" 
              />
            </h2>
            <p className="text-sm text-gray-700 mt-2 mb-7">
              <FormattedMessage
                id="subscription_remaining_days"
                defaultMessage="Expires in {days} {days, plural, one {day} other {days}} on {expiryDate}."
                values={{
                  days: daysRemaining,
                  expiryDate: new Date(subscriptionData.current_period_end).toLocaleDateString()
                }}
              />
            </p>
          </>
        )}

        <div className="mb-2">
          <div
            onClick={handleRedirection}
            className="btn btn-primary hover:bg-secondary"
          >
            <FormattedMessage 
              id="upgrade_plan" 
              defaultMessage="Renew Subscription" 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionBanner;